export default __webpack_public_path__ + "static/media/meals.2971f633.jpeg";